import { render, staticRenderFns } from "./CourseCompareButton.vue?vue&type=template&id=50bcc4aa&"
import script from "./CourseCompareButton.vue?vue&type=script&lang=js&"
export * from "./CourseCompareButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports